import { useParams } from 'react-router';

export const useExaminerId = () => {
  const { examinerId } = useParams<{ examinerId: string }>();

  if (!examinerId || examinerId.trim() === '') {
    throw new TypeError('Invalid examiner id');
  }

  const numericId = Number(examinerId);

  if (Number.isNaN(numericId)) {
    throw new TypeError('Invalid examiner id');
  }

  return numericId;
};
